import { isPlainObject, omit } from "lodash";
import { showError } from "./context";
import { deleteEmptyKey, go } from "./utils";

/**
 * 异步函数超时逻辑
 * @param {*} asyncFunc
 * @param {*} time
 * @returns
 */
export async function timeoutPass(asyncFunc, time = 30000) {
  return Promise.race([
    asyncFunc(),
    new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          code: -9999,
          message: "请求超时",
          data: null,
        });
      }, time);
    }),
  ]);
}

/**
 * 根据路径获取完整URL
 * @param {*} pathname
 * @returns
 */
export function getUrl(pathname) {
  if (-1 !== pathname.indexOf("http")) {
    return pathname.replace(/^\/*/, "");
  }
  const origin = import.meta.env.VITE_SERVICE_API.replace(/\/*$/, "");
  const host = window.location.protocol + "//" + origin;
  return host + "/" + pathname.replace(/^\/*/, "");
}

/**
 * 分离配置
 * @param option
 * @returns
 */
function splitOption(option) {
  let timeout = 30000;
  let init = {};
  if (isPlainObject(option)) {
    timeout = option.timeout ?? timeout;
    init = omit(option, ["timeout"]);
  }
  return { timeout, init };
}

/**
 * 发送GET请求
 * @param pathname string
 * @param data JSONObject
 * @param option RequestClientOption
 * @returns
 */
export async function get(pathname, data, option) {
  const uobj = new URL(getUrl(pathname));
  if (isPlainObject(data)) {
    deleteEmptyKey(data);
    for (let key in data) {
      uobj.searchParams.append(key, data[key]);
    }
  }

  const { timeout, init } = splitOption(option);
  init.credentials = "include";
  init.method = "GET";
  return timeoutPass(async () => {
    const response = await fetch(uobj, init);
    const res = response.json();
    if (res && checkReLogin(res.code)) {
      showError(res.message);
      return go("/login");
    }
    return res;
  }, timeout);
}

/**
 * 发送常规POST请求
 * @param pathname string
 * @param data JSONObject | URLSearchParams | FormData
 * @param option RequestClientOption
 * @returns
 */
export async function post(pathname, data, option) {
  const uobj = new URL(getUrl(pathname));
  data ||= {};
  let sendBody = null;
  if (isPlainObject(data)) {
    deleteEmptyKey(data);
    sendBody = new URLSearchParams(data);
  } else {
    sendBody = data;
  }

  const { timeout, init } = splitOption(option);
  init.credentials = "include";
  init.method = "POST";
  init.credentials = "include";
  init.body = sendBody;
  return timeoutPass(async () => {
    try {
      const response = await fetch(uobj, init);
      const res = response.json();
      if (res && checkReLogin(res.code)) {
        showError(res.message);
        return go("/login");
      }
      return res;
    } catch (e) {
      console.error(e);
      showError(e.message);
      throw e;
    }
  }, timeout);
}

function checkReLogin(code) {
  return [10010].includes(code);
}

/**
 * 发送application/json请求，POST格式，请求体为JSON字符串
 * @param pathname string
 * @param data JSONObject
 * @param option RequestClientOption
 * @returns
 */
export async function json(pathname, data, option) {
  const uobj = new URL(getUrl(pathname));
  let body = {};
  if (isPlainObject(data)) {
    deleteEmptyKey(data);
    body = { ...data };
  }

  const { timeout, init } = splitOption(option);
  init.credentials = "include";
  init.method = "POST";
  init.credentials = "include";
  let typeHeader = {
    "Content-Type": "application/json",
  };

  if (isPlainObject(init.headers)) {
    init.headers = {
      ...init.headers,
      ...typeHeader,
    };
  } else {
    init.headers = typeHeader;
  }

  init.body = JSON.stringify(body);
  return timeoutPass(async () => {
    const response = await fetch(uobj, init);
    const res = await response.json();
    if (res && checkReLogin(res.code)) {
      showError(res.message);
      return go("/login");
    }
    return res;
  }, timeout);
}
